'use strict';

var index = (function () {});

module.exports = index;
